const config = {
  local: {
    apiPath: 'http://127.0.0.1:18083',
    imgurl: 'http://hui.zpyhsc.com/zp-images/bank/'
  },
  dev: {
    apiPath: 'hui-zpyh',
    imgurl: 'http://new-images.zpyhsc.com/bank/'
  },
  test: {
    apiPath: 'http://47.94.245.248:8088',
    imgurl: 'http://hui.zpyhsc.com/zp-images/bank/'
  },
  prod: {
    apiPath: 'http://hui.zpyhsc.com/zp-web/',
    imgurl: 'http://hui.zpyhsc.com/zp-images/bank/'
  }
};
const type = '';
export default config[type || process.env.TYPE];



// WEBPACK FOOTER //
// ./src/config/index.js